//Library Imports
import { useState, useEffect, useRef } from "react";
import { Select, Tooltip, Typography } from "antd";
import { useSelector } from "react-redux";
import { RootState } from "store";
import styled from "styled-components";

// application components goes here
import DropdownArrow from "../../../../assets/img/icons/dropdownarrow.svg";
import { ReactComponent as SearchIcon } from "../../../../assets/img/icons/search.svg";
import { ReactComponent as SearchCross } from "../../../../assets/img/icons/SearchCross.svg";
import Checkbox from "../../../Common/Components/Checkbox";
import { getOrganizations } from "../actions";
import { getQueryListId } from "utils";

type FilterDropdownOrganizationProps = {
  selectedOrganization: string[];
  setSelectedOrganization: (value: string[]) => void;
  fetchData?: () => void;
};

const FilterDropdownOrganization: React.FC<FilterDropdownOrganizationProps> = (
  props: FilterDropdownOrganizationProps
) => {
  // Local States
  const { selectedOrganization, setSelectedOrganization, fetchData } = props;
  const selectRef = useRef<HTMLDivElement>(null);
  const customSelectRef = selectRef?.current;
  const [openDropdown, setOpenDropdown] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  // const [organizations, setOrganizations] = useState([]);
  const [checkedOrganizations, setCheckedOrganizations] = useState([]);
  const [uncheckedOrganizations, setUncheckedOrganizations] = useState([]);
  const [firstLoad, setFirstLoad] = useState(true);

  // Redux States
  const organizations = useSelector((state: RootState) => state.peopleAudience.organizations);
  const organizationsLoading = useSelector((state: RootState) => state.peopleAudience.organizationsLoading);

  // Component Logic
  const stopClickEvent = (e: any) => {
    e.stopPropagation();
  };

  useEffect(() => {
    // bind click events on campaign dropdwon
    window.addEventListener(".campaigns-list click", function (e: any) {
      if (!customSelectRef?.contains(e.target)) {
        customSelectRef?.classList.remove("open");
      }
    });
    segregateOrganizations();
    return () => {
      window.removeEventListener(".campaigns-list click", function (e: any) {
        if (!customSelectRef?.contains(e.target)) {
          customSelectRef?.classList.remove("open");
        }
      });
    };
    // don't forget to remove the event listeners when the component unmounts
  }, []);

  const checkboxClickHandler = (checked: boolean, value: string) => {
    if (checked) {
      setSelectedOrganization([...selectedOrganization, value]);
    } else {
      setSelectedOrganization(selectedOrganization.filter((organization) => organization !== value));
    }
  };

  // useEffect(() => {
  //   setOrganizations(organizationsReducerState);
  // }, [organizationsReducerState]);

  const searchInputHandler = (e: any) => {
    setSearchValue(e.target.value);
    if (e.target.value === "") {
      getOrganizations(getQueryListId().toString());
    }
  };

  const updateSearchTerm = () => {
    setSearchValue(searchValue.trim());
    getOrganizations(getQueryListId().toString(), searchValue.trim());
  };

  // const searchOrganizations = () => {
  //   const searchedOrganizations = organizationsReducerState.filter((organization: any) =>
  //     organization.name.toLowerCase().includes(searchValue.toLowerCase().trim())
  //   );
  //   setOrganizations(searchedOrganizations);
  // };

  // useEffect(() => {
  //   if (searchValue.length > 0) {
  //     searchOrganizations();
  //   } else {
  //     setOrganizations(organizationsReducerState);
  //   }
  // }, [searchValue]);

  const segregateOrganizations = () => {
    // This function segregates the organizations into checked and unchecked
    let checkedOrganizationsArray: any = [];
    let uncheckedOrganizationsArray: any = [];
    organizations?.map((organization: any) => {
      if (selectedOrganization.includes(organization.name)) {
        checkedOrganizationsArray.push(organization);
      } else {
        uncheckedOrganizationsArray.push(organization);
      }
    });
    setCheckedOrganizations(checkedOrganizationsArray);
    setUncheckedOrganizations(uncheckedOrganizationsArray);
  };

  useEffect(() => {
    if (!openDropdown) {
      segregateOrganizations(); // call this function when user closes the dropdown to segregate the organizations
      // setSearchValue(""); // reset the search value
      if (searchValue.length > 0) {
        setSearchValue(""); // reset the search value
        //! need to refactor this later
        if (fetchData) fetchData(); // call the fetchData function to fetch the data from the API
      }
    }
  }, [openDropdown]);

  useEffect(() => {
    // for the first time it will show data in the dropdown
    if (firstLoad && organizations.length > 0) {
      segregateOrganizations();
      //setFirstLoad(false);
    }
  }, [organizations]);

  return (
    <StyleWrapper selectedOrganization={selectedOrganization}>
      <div className="custom-select-wrapper" onClick={() => setOpenDropdown(!openDropdown)}>
        <div ref={selectRef} className={`campaigns-list custom-select ${openDropdown ? "open" : ""} `}>
          <div className="overlay-campaign-list"></div>
          <div className="custom-select__trigger">
            <span>{"Company"}</span>
          </div>
          <div>
            <div className="arrow-dropdown">
              <img src={DropdownArrow} />
            </div>
          </div>

          <div className="custom-options">
            <div className="search-field padding-sm" onClick={(e) => stopClickEvent(e)}>
              <div className="search-wraper">
                <div className="search-bar">
                  <span className="refresh-search">
                    <SearchIcon />
                  </span>

                  <input
                    type="text"
                    name="search"
                    className="search-input"
                    placeholder="Search Company e.g. xiQ..."
                    value={searchValue}
                    onChange={searchInputHandler}
                    onKeyPress={(e: any) => {
                      if (e.key === "Enter") {
                        updateSearchTerm();
                      }
                    }}
                  />
                  {searchValue ? (
                    <span
                      onClick={() => {
                        setSearchValue("");
                        getOrganizations(getQueryListId().toString());
                      }}
                      className="clear-search"
                    >
                      <SearchCross />
                    </span>
                  ) : null}
                </div>
              </div>
            </div>

            {organizationsLoading ? (
              <ul
                onClick={(e) => stopClickEvent(e)}
                className="select-options padding-md scrollable scrollableCustom"
              >
                <li>{"Fetching Companies..."}</li>
              </ul>
            ) : (
              <ul
                onClick={(e) => stopClickEvent(e)}
                className="select-options padding-md scrollable scrollableCustom org-option"
              >
                {organizations.length > 0 ? (
                  <>
                    {checkedOrganizations
                      // .filter((organization: any) =>
                      //   organization.name.toLowerCase().includes(searchValue.toLowerCase().trim())
                      // )
                      .map(({ name }, index) => {
                        let isChecked = selectedOrganization.includes(name);
                        if (index <= 50) {
                          return (
                            <li key={name}>
                              <Checkbox
                                className="checkbox"
                                onChange={() => checkboxClickHandler(!isChecked, name)}
                                checked={selectedOrganization.indexOf(name) > -1}
                                value={name}
                                width="18px"
                                height="18px"
                              />
                              <Tooltip
                                placement="top"
                                title={name}
                                getPopupContainer={() =>
                                  document.querySelectorAll(".org-option")[0] as HTMLElement
                                }
                              >
                                <span onClick={() => checkboxClickHandler(!isChecked, name)}>{name}</span>
                              </Tooltip>
                            </li>
                          );
                        }
                      })}
                    {uncheckedOrganizations
                      // .filter((organization: any) =>
                      //   organization.name.toLowerCase().includes(searchValue.toLowerCase().trim())
                      // )
                      .map(({ name }, index) => {
                        let isChecked = selectedOrganization.includes(name);
                        if (index < 50 - checkedOrganizations.length) {
                          return (
                            <li key={name}>
                              <Checkbox
                                className="checkbox"
                                onChange={() => checkboxClickHandler(!isChecked, name)}
                                checked={selectedOrganization.indexOf(name) > -1}
                                value={name}
                                width="18px"
                                height="18px"
                              />
                              <Tooltip
                                placement="top"
                                title={name}
                                getPopupContainer={() =>
                                  document.querySelectorAll(".org-option")[0] as HTMLElement
                                }
                              >
                                <span onClick={() => checkboxClickHandler(!isChecked, name)}>{name}</span>
                              </Tooltip>
                            </li>
                          );
                        }
                      })}
                  </>
                ) : (
                  <li>{"No Company Found"}</li>
                )}
              </ul>
            )}
          </div>
        </div>
      </div>
    </StyleWrapper>
  );
};

export default FilterDropdownOrganization;

const { Option } = Select;

const ArrowIcon = (
  <div
    style={{
      height: "22px",
      paddingLeft: "8px",
      paddingTop: "4px",
      paddingRight: "8px",
      borderLeft: "solid 1px #DDDDDD",
    }}
  >
    <img src={DropdownArrow} />
  </div>
);

const StyleWrapper = styled.div<{ selectedOrganization: string[] }>`
  width: 100%;
  .paragraph-styling {
    overflow: hidden;
    font-family: "Roboto";
    font-weight: 500;
    color: #7e7e7e;
    margin-bottom: 0;
  }
  .disable {
    pointer-events: none;
  }
  .fetch-text {
    font-size: 12px;
    font-weight: 600;
    color: #5e7079;
  }
  .search-wraper {
    position: relative;
    width: 100%;
    .search-results {
      border-radius: 22px;
      position: absolute;
      top: -80px;
      left: 0;
      // display: none;
      float: left;

      width: 100%;
      border: 1px solid #dadada;
      box-shadow: 0 0 24px 0 rgba(0, 0, 0, 0.12);
      overflow: hidden;
      transition: 0.5s;
      z-index: -1;
      opacity: 0;
      visibility: hidden;
      &.show {
        opacity: 1;
        z-index: 1;
        visibility: visible;
      }
      ul.results-list {
        background: #fff;
        padding: 30px 55px 10px 55px;
        margin: 0;
        list-style: none;
        float: left;
        display: block;
        width: 100%;
        transition: 0.5s;
        li {
          color: #5e7079;
          font-size: 16px;
          line-height: 34px;
          padding: 0;
          list-style: none;
          float: left;
          width: 100%;
          display: block;
          cursor: pointer;
          transition: 0.5s;
        }
      }
      .relevant-theme,
      .relevant-company {
        border-top: 1px solid #dadada;
        padding: 10px 40px 30px 40px;
        background: #f7f7f7;
        float: left;
        width: 100%;
        transition: 0.5s;
        h3 {
          margin-bottom: 10px;
          color: #424b50;
          font-weight: 400;
          font-family: "Roboto Slab", serif;
          font-size: 18px;
          line-height: 34px;
        }
      }
      .search-hint {
        background: #def6e6;
        padding: 18px 25px 36px 25px;
        border-radius: 22px 22px 0 0;
        float: left;
        width: 100%;
        svg {
          float: left;
          width: 35px;
          height: 39px;
        }
        ul {
          margin: 0;
          float: left;
          li {
            color: #09a43a;
            font-size: 14px;
            font-weight: 400;
            list-style: none;
            strong {
              font-weight: 700;
            }
          }
        }
      }
    }
    .search-bar {
      border-radius: 27px;
      background: #ffffff;
      border: 1px solid #dadada;
      display: block;
      float: left;
      width: 100%;
      overflow: hidden;
      position: relative;
      margin: 5px 0;
      span.clear-search {
        float: right;
        margin-top: 5px;
        margin-right: 12px;
        transition: 0.5s;
        cursor: pointer;
        width: auto;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          margin-top: 0px;
          margin-right: 8px;
        }
        svg {
          @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
            width: 10px;
          }
        }
      }
      span.refresh-search {
        padding-right: 5px;
        border-right: 1px solid #dadada;
        margin: 6px 8px;
        float: left;
        cursor: pointer;
        width: auto;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          margin: 3px 7px 3px 7px;
          line-height: 12px;
        }
        svg {
          @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
            width: 14px;
          }
        }
        svg path {
          fill: #424b50;
        }
      }
      .search-input {
        float: left;
        border: none;
        outline: none;
        width: calc(100% - 70px);
        display: block;
        color: #424b50;
        font-weight: 400;
        font-size: 14px;
        margin-top: 5px;
        margin-bottom: 2px;
        font-family: "robotoregular";
        -webkit-box-shadow: 0 0 0 30px white inset !important;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          font-size: 10px;
          margin-top: 3px;
          width: calc(100% - 60px);
        }
        &::-webkit-input-placeholder {
          font-family: "robotothin_italic";
          color: #c1c1c1;
        }
        &:-moz-placeholder {
          font-family: "robotothin_italic";
          color: #c1c1c1;
        }
        &::-moz-placeholder {
          font-family: "robotothin_italic";
          color: #c1c1c1;
        }
        &:-ms-input-placeholder {
          font-family: "robotothin_italic";
          color: #c1c1c1;
        }
        &:hover,
        &:active,
        &:focus {
          border: none;
          outline: none;
        }
      }
    }
  }
  .scrollableCustom {
    overflow: scroll;
    /* height: 110px; */
    overflow-x: hidden;
    /* @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      height: 110px;
    } */
    scrollbar-width: thin;
    scrollbar-color: #001760 transparent;
    &::-webkit-scrollbar {
      width: 5px;
      height: 5px;
      border-radius: 5px;
    }
    /* Track */
    &::-webkit-scrollbar-track {
      background: #fff;
      margin-top: 10px;
      margin-bottom: 15px;
    }
    /* Handle */
    &::-webkit-scrollbar-thumb {
      background: #001760;
    }
    /* Handle on hover */
    &::-webkit-scrollbar-thumb:hover {
      background: #555;
    }
  }
  .assetInput {
    width: 100%;
    border: solid 1px #dadada;
    padding: 5px 12px;
    font-size: 16px;
    color: #7e7e7e;
    font-family: "robotomedium", sans-serif;
    border-radius: 8px;
    &:focus,
    &:active {
      outline: none;
    }
  }
  .custom-select-wrapper {
    position: relative;
    user-select: none;
    width: 100%;
  }
  .custom-select {
    position: relative;
    display: flex;
    flex-direction: column;
    border-width: 0;
    border-style: solid;
  }
  .custom-select__trigger {
    position: relative;
    /* display: flex; */
    /* align-items: center;
    justify-content: space-between; */
    /* padding: 0 22px 10px 22px; */
    height: 36px;
    line-height: 28px;
    background: ${(props) => (props.selectedOrganization.length > 0 ? "#def6e6" : "#ffffff")};
    cursor: pointer;
    border: solid 1px #dadada;
    padding: 3px 35px 3px 15px;
    font-size: 16px;
    color: ${(props) => (props.selectedOrganization.length > 0 ? "#09a43a" : "#7e7e7e")};
    font-family: "robotomedium", sans-serif;
    border-radius: 8px;
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 100%;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      font-size: 12px;
      padding: 7px 35px 7px 10px;
      line-height: 12px;
      height: 30px;
      border-radius: 6px;
    }
    span {
      overflow: hidden;
      width: 100%;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .arrow-dropdown {
    position: absolute;
    top: 8px;
    right: 4px;
    height: 22px;
    padding-left: 8px;
    padding-top: 0;
    padding-right: 8px;
    border-left: solid 1px #dddddd;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      top: 7px;
      height: 15px;
      line-height: 14px;
    }
  }
  .custom-options {
    background-color: #fff;
    position: absolute;
    display: block;
    top: 120%;
    left: 0;
    right: 0;
    background: #fff;
    /* transition: all 0.5s; */
    opacity: 0;
    visibility: hidden;
    pointer-events: none;
    z-index: 999;
    border-radius: 8px;
    border: solid 1px #dadada;
    padding-bottom: 1em;
    box-shadow: 0px 0px 28px rgba(0, 0, 0, 0.28);
    overflow: hidden;
    /* @media all and (max-height: 850px) {
      top: auto;
      bottom: calc(100% + 5px);
    } */
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      border-radius: 6px;
    }
    .search-field {
      display: flex;
      flex: 1;
      background-color: #fff;
      border-radius: 8px;
    }
    .new-campaign {
      border-top: 1px solid #dadada;
      border-bottom: 1px solid #dadada;
      cursor: pointer;
      h3 {
        margin: 0;
        font-size: 16px;
        color: #7e7e7e;
        font-family: "robotomedium", sans-serif;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          font-size: 12px;
        }
      }
    }
    .select-options {
      list-style-type: none;
      margin: 0;
      padding: 0px 10px;
      max-height: 360px;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        max-height: 310px;
      }
      li {
        font-family: "robotomedium", sans-serif;
        font-size: 16px;
        color: #7e7e7e;
        /* cursor: pointer; */
        transition: 0.5s;
        /* width: 460px; */
        width: calc(100% - 5px);
        display: block;
        align-items: center;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        line-height: 2;
        &:hover {
          /* margin-left: 5px;
          transition: 0.5s; */
          color: #27ce0a;
          cursor: pointer;
        }
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          /* font-size: 12px; */
        }
      }
    }
  }
  .custom-select.open .custom-options {
    opacity: 1;
    visibility: visible;
    pointer-events: all;
    width: 290px;
    padding: 5px 10px 10px 10px;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      width: 230px;
    }
  }
  .custom-option {
    position: relative;
    display: block;
    font-size: 22px;
    font-weight: 300;
    color: #3b3b3b;
    line-height: 60px;
    cursor: pointer;
    transition: all 0.5s;
  }
  .custom-option:hover {
    cursor: pointer;
    background-color: #b2b2b2;
  }
  .custom-option.selected {
    color: #ffffff;
    background-color: #305c91;
  }

  .arrow {
    position: relative;
    height: 15px;
    width: 15px;
  }
  .arrow::before,
  .arrow::after {
    content: "";
    position: absolute;
    bottom: 0px;
    width: 0.15rem;
    height: 100%;
    transition: all 0.5s;
  }
  .arrow::before {
    left: -5px;
    transform: rotate(45deg);
    background-color: #394a6d;
  }
  .arrow::after {
    left: 5px;
    transform: rotate(-45deg);
    background-color: #394a6d;
  }
  .open .arrow::before {
    left: -5px;
    transform: rotate(-45deg);
  }
  .open .arrow::after {
    left: 5px;
    transform: rotate(45deg);
  }
  .overlay-campaign-list {
    position: fixed;
    top: 0px;
    left: 0px;
    width: 100vw;
    height: 100vh;
    z-index: -999;
  }
  .open {
    .overlay-campaign-list {
      z-index: 15;
    }
  }
`;
